import React from 'react';
import ShieldIcon from '@mui/icons-material/Shield';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'code', label: 'Code', required: true, helperText: 'As printed on labels, e.g. "9", "1B", "M3"' },
  {
    key: 'pesticideType',
    label: 'Type',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/mode-of-action-groups/types',
  },
  { key: 'description', label: 'Mode of Action', helperText: 'From the CropLife Australia table' },
  { key: 'sortIndex', label: 'Sort Order', type: 'number' },
];

// Resistance-management groups picked on Active Ingredients; the name
// ("Group 9 Herbicide") is built from Code + Type by the API.
const ModeOfActionGroupManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Mode of Action Group Management"
    icon={<ShieldIcon />}
    apiPath="/api/mode-of-action-groups"
    fields={fields}
    entityLabel="Mode of Action Group"
  />
);

export default ModeOfActionGroupManagement;
